<template>
	<MStateBox :loading="wrapper.loading" :empty="wrapper.isEmpty">
		<div
			class="chart"
			:class="{ 'chart-with-tabs': wrapper.tabList && wrapper.tabList.length }"
			:key="`${wrapper.value}_${wrapper.active}`"
		>
			<div class="legend-container">
				<div class="legend-wrapper" v-for="(item, index) in wrapper.legend" :key="index">
					<span class="legend-item" :style="{ background: item.color }"></span>{{ item.name }}
				</div>
			</div>
			<div class="chart-container">
				<m-line-bar v-bind="wrapper.chartData" @finished="handleFinished"></m-line-bar>
			</div>
		</div>
	</MStateBox>
</template>

<script setup>
import MStateBox from '@rebuild/components/MStateBox.vue';

const props = defineProps({
	wrapper: { type: Object, required: true }
});

function handleFinished(chart) {
	chart.dispatchAction({
		type: 'showTip',
		seriesIndex: 0,
		dataIndex: props.wrapper.data.length - 1
	});
}
</script>

<style lang="less" scoped>
.chart {
	margin-top: 0.2rem;
	width: 100%;
	height: 2.5rem;
	display: flex;
	flex-direction: column;
}

.chart-with-tabs {
	margin-top: 0.08rem;
}

.legend-container {
	margin-bottom: 0.08rem;
	width: 100%;

	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;

	.legend-wrapper {
		display: flex;
		align-items: center;

		color: #666;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.17rem;
		white-space: nowrap;
	}
	.legend-wrapper + .legend-wrapper {
		margin-left: 0.24rem;
	}

	.legend-item {
		margin-right: 0.05rem;
		width: 0.1rem;
		height: 0.1rem;
		border-radius: 0.02rem;
	}
}

.chart-container {
	flex: 1;
	width: 100%;
	min-height: 0;
}
</style>
